import { render, staticRenderFns } from "./AdditionalSampleEvaluationTab.vue?vue&type=template&id=3f5dbea2&scoped=true&"
import script from "./AdditionalSampleEvaluationTab.vue?vue&type=script&lang=js&"
export * from "./AdditionalSampleEvaluationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5dbea2",
  null
  
)

export default component.exports